import axiosInstance from "../utils/axios";

export const CreateNotes = async (values) => {
  return await axiosInstance().post(`/createNotesUsed`, values);
};

export const DeleteNotes = async (values) => {
  return await axiosInstance().post(`/deleteNotesUsed`, values);
};

export const ListNotesCancelToken = async (values, cancelToken) => {
  return await axiosInstance().post(`/listNotesUses`, values, {cancelToken});
}; 
export const GetTemplateListCancelToken = async (values, cancelToken) => {
  return await axiosInstance().post(`/getPCTemplateList`, values, {
    cancelToken: cancelToken
  });
};

export const GetTemplateListFilters = async (cancelToken) => {
  return await axiosInstance().get(`/getPCTemplateListFilters`, {
    cancelToken: cancelToken
  });
};
export const GetPCProject = async (id, cancelToken) => {
  return await axiosInstance().get(`/getPCProject?id=${id}`, {
    cancelToken: cancelToken
  });
}

export const DeletePCProject = async (id) => {
  return await axiosInstance().post(`/deletePCProject`, { id: id })
};
export const GetPCTemplate = async (id, cancelToken) => {
  return await axiosInstance().get(`/getPCTemplate?id=${id}`, {
    cancelToken: cancelToken
  });
}

export const UpdatePCTemplate = async (values) => {
  return await axiosInstance().post(`/updatePCTemplate`, values);
};
export const UpdatePCProject = async (values) => {
  return await axiosInstance().post(`/updatePCProject`, values);
}
export const DeleteTemplate = async (id) => {
  return await axiosInstance().post(`/deletePCTemplate`,{id:id})
};

export const GetPCProjectList = async (values, cancelToken) => {
  return await axiosInstance().post(`/getPCProjectList`, values, {
    cancelToken: cancelToken
  });
}
export const GetPCProjectListFilters = async (cancelToken) => {
  return await axiosInstance().get(`/getPCProjectListFilters`, {
    cancelToken: cancelToken
  });
}
export const AuditTrailPC = async (values, cancelToken) => {
  return await axiosInstance().post(`/auditTrailPC`, values, {
    cancelToken: cancelToken
  });
};
export const AuditTrailFilterPC = async (values,cancelToken) => {
  return await axiosInstance().get(`/auditTrailFilterPC`, { params: values, cancelToken: cancelToken });
}